// extracted by mini-css-extract-plugin
export default {"pulse":"SplashScreen_pulse__HUihb","pulseFrame":"SplashScreen_pulseFrame__-A5TH"};